import SupportTicketForm from './components/SupportTicketForm.vue';
import SupportTicketPortal from './components/SupportTicketPortal.vue';
import TicketList from './components/TicketList.vue';
import TicketThread from './components/TicketThread.vue';

/**
 * Isolated component bundle entry for the new support ticket portal (design doc §12.2/§12.3/§8),
 * mirroring main-accountcomponents.js's registration pattern without touching that file.
 * Actual app creation/mounting + i18n wiring is handled by main-corecomponents.js, driven by
 * window.VcComponents entries (see index-supportticket.html).
 */
console.log("Starting VcSupportTicketComponentLoader...");

const SUPPORTTICKETCOMPONENTS = {
    'SupportTicketForm': SupportTicketForm,
    'SupportTicketPortal': SupportTicketPortal,
    'TicketList': TicketList,
    'TicketThread': TicketThread,
};

window.VcAvailableComponents = (window.VcAvailableComponents && { ...window.VcAvailableComponents, ...SUPPORTTICKETCOMPONENTS }) || SUPPORTTICKETCOMPONENTS;
